import type { ItemResult } from '@creanizer/types'

export function getRarityIcon(rarity: string) {
  const icons: Record<string, JSX.Element> = {
    common: <span className="text-gray-500">●</span>,
    uncommon: <span className="text-green-500">●</span>,
    rare: <span className="text-blue-500">●</span>,
    epic: <span className="text-purple-500">●</span>,
    legendary: <span className="text-orange-500">●</span>,
    mythic: <span className="text-red-500">●</span>,
    unique: <span className="text-yellow-500">★</span>
  }
  return icons[rarity] || icons.common
}

export function formatBasicInfo(result: ItemResult): string {
  const info = result.basicInfo
  return `【${info.name}】
タイプ: ${info.type}
カテゴリ: ${info.category}
レア度: ${info.rarity}

${info.summary}

${info.description}`
}

export function formatEffects(result: ItemResult): string {
  const effects = result.effects
  let text = `【主要効果】
${effects.primaryEffect.description}
効果の強さ: ${effects.primaryEffect.magnitude}`

  if (effects.primaryEffect.duration) {
    text += `\n持続時間: ${effects.primaryEffect.duration}`
  }

  if (effects.secondaryEffects && effects.secondaryEffects.length > 0) {
    text += '\n\n【副次効果】'
    effects.secondaryEffects.forEach(effect => {
      text += `\n・${effect.description}`
    })
  }

  return text
}

export function formatAcquisition(result: ItemResult): string {
  const acquisition = result.acquisition
  let text = `【入手情報】`

  text += `\n推定価値: ${acquisition.estimatedValue}`
  if (acquisition.currency) {
    text += ` ${acquisition.currency}`
  }
  
  text += `\nレア度: ${acquisition.rarity}`
  
  if (acquisition.demandLevel) {
    text += `\n需要: ${acquisition.demandLevel}`
  }
  
  if (acquisition.availability) {
    text += `\n入手可能性: ${acquisition.availability}`
  }
  
  if (acquisition.valueFluctuation) {
    text += `\n価値変動: ${acquisition.valueFluctuation}`
  }

  text += '\n\n【入手方法】'
  acquisition.obtainMethod.forEach(method => {
    text += `\n・${method}`
  })

  if (acquisition.locations && acquisition.locations.length > 0) {
    text += '\n\n【入手場所】'
    acquisition.locations.forEach(location => {
      text += `\n・${location}`
    })
  }
  
  if (acquisition.dropRate) {
    text += `\n\n【ドロップ率】\n${acquisition.dropRate}`
  }

  if (acquisition.quest) {
    text += `\n\n【クエスト報酬】`
    text += `\nクエスト名: ${acquisition.quest.name}`
    text += `\n依頼主: ${acquisition.quest.giver}`
  }

  return text
}

export function formatLore(result: ItemResult): string {
  const lore = result.lore
  let text = `【伝承】\n`
  
  // 新しいoriginStory構造と古いorigin構造の両方に対応
  if ((lore as any).originStory) {
    const story = (lore as any).originStory
    text += story.narrative || ''
    if (story.purpose) {
      text += `\n目的: ${story.purpose}`
    }
    if (story.creator) {
      text += `\n創造者: ${story.creator}`
    }
    if (story.era) {
      text += `\n時代: ${story.era}`
    }
    if (story.location) {
      text += `\n場所: ${story.location}`
    }
  } else if ((lore as any).origin) {
    const origin = (lore as any).origin
    text += `起源: ${origin.purpose || ''}`
    if (origin.creator) {
      text += `\n創造者: ${origin.creator}`
    }
  }

  // history field check with type guard
  if ((lore as any).history && (lore as any).history.length > 0) {
    text += '\n\n【歴史】'
    ;(lore as any).history.forEach((event: any) => {
      text += `\n${event.period}: ${event.event}`
    })
  }

  if (lore.flavorText) {
    text += `\n\n"${lore.flavorText}"`
  }

  return text
}